'use strict'

// TODO: not sure how, but should define a proper protocol id
//       dependent on Y.js protocol version
exports.id = '/yjs/12.3.0/'



//////////////////
// WEBPACK FOOTER
// ./~/y-ipfs-connector/src/protocol.js
// module id = 336
// module chunks = 0